<template>
  <base-section
    id="info-alt"
    space="56"
  >
    <v-container>
      <v-row justify="space-between">
        <v-col
          class="hidden-sm-and-down"
          cols="12"
          md="5"
        >
          <!-- <base-business-info title="KEEP IN TOUCH WITH US">
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illo pariatur quidem, quis modi iure nihil commodi suscipit, corporis dicta adipisci, voluptatum quia cupiditate.
          </base-business-info> -->
          <!-- <base-section-heading title="Contáctanos" /> -->
          <base-info-card
            title="CONTÁCTANOS POR EMAIL"
            pace="6"
          />
          <v-img :src="require('@/assets/tarjeta-visita-2.png')" />
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <base-contact-form title="ENVÍANOS UN MENSAJE" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionKeepInTouch',
  }
</script>
